var staticParseInt = require('./staticParseInt')

var helperCreateToNumber = require('./helperCreateToNumber')

/**
 * 转整数
 * @param { String/Number } str 数值
 *
 * @return {Number}
 */
var toInteger = helperCreateToNumber(staticParseInt)

module.exports = toInteger



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/toInteger.js
// module id = 1184
// module chunks = 75